/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AlbumResponse } from '../../models/album-response';
import { UpdateAlbumDto } from '../../models/update-album-dto';

export interface AlbumsControllerUpdate$Params {
  id: string;
      body: UpdateAlbumDto
}

export function albumsControllerUpdate(http: HttpClient, rootUrl: string, params: AlbumsControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<AlbumResponse>> {
  const rb = new RequestBuilder(rootUrl, albumsControllerUpdate.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AlbumResponse>;
    })
  );
}

albumsControllerUpdate.PATH = '/albums/admin/{id}';
